<script setup lang="ts">
const _props = defineProps<{
  theme: string | null | undefined
  data: {
    medias: { image: unknown; video: unknown }[]
  }
}>()

const { isMobileOrTablet } = useDevice()
const { width: innerWidth } = useWindowSize()

const isMobile = computed(() => {
  if (import.meta.server) return isMobileOrTablet
  return innerWidth.value < 900
})

provide('showMediaCaption', true)
</script>

<template>
  <div class="gallery relative">
    <div v-if="!isMobile" class="px-bleed grid grid-cols-2 gap-(--grid-gap) gap-y-15">
      <div
        v-for="(media, index) in data?.medias"
        :key="index"
        class="media wrapper grid h-fit gap-4"
        :class="[
          `${index % 4 === 0 || index % 4 === 3 ? '!w-cols-6' : '!w-cols-5'}`,
          `${index % 4 === 1 ? 'ml-auto' : ''}`,
        ]"
      >
        <CommonMedia :media="media" class="h-auto w-full overflow-clip rounded-sm object-cover" />
        <p v-if="media.image?.caption" class="text-base">{{ media.image?.caption }}</p>
      </div>
    </div>
    <CarouselsCards v-else class="lg:hidden"
      ><div
        v-for="(media, index) in data?.medias"
        :key="index"
        class="media wrapper embla__slide grid h-fit gap-2"
      >
        <CommonMedia :media="media" class="h-auto w-full overflow-clip rounded-sm object-cover" />
        <p v-if="media.image?.caption" class="text-base">{{ media.image?.caption }}</p>
      </div></CarouselsCards
    >
  </div>
</template>
